import Swiper from 'swiper';
import { debounce } from 'debounce';
class Tiles {
    constructor(container, numberSlides, swiperNext, swiperPrev) {
        this.swiper = null;
        this.slides = 0;
        // Best window width max values to add the swiper. This values are also in the tiles.scss.
        // 706px/16px;
        this.twoColumnsMaxmimumWidthInEms = 44.125;
        // 1023 / 16px
        this.threeColumnsMaxmimumWidthInEms = 63.9375;
        // 1376 / 16px
        this.fourColumnsMaxmimumWidthInEms = 86;
        this.addSwiper = (overrideSwiper) => {
            if (!this.swiper || overrideSwiper) {
                if (this.swiper && overrideSwiper) {
                    this.destroySwiper();
                    this.swiper = null;
                }
                let slidesPerView = 1;
                if (this.swiperContainer && ((this.swiperContainer || {}).dataset || {}).slidesPerView == 'auto') {
                    slidesPerView = 'auto';
                }
                this.swiper = new Swiper(this.swiperContainer, {
                    grabCursor: true,
                    mousewheel: false,
                    slidesPerView: slidesPerView,
                    spaceBetween: ((this.swiperContainer || {}).dataset || {}).gap ? parseInt((((this.swiperContainer || {}).dataset || {}).gap).replace('px', '')) : 0,
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        hide: false,
                    },
                });
            }
        };
        this.destroySwiper = () => {
            if (this.swiper) {
                this.swiper.destroy();
                this.swiper = null;
            }
        };
        this.swiperContainer = container;
        this.slides = numberSlides;
        this.nextElement = document.querySelector(swiperNext);
        this.prevElement = document.querySelector(swiperPrev);
        const onWindowResize = debounce((overrideSwiper = false) => {
            const widthInEms = window.innerWidth / 16;
            let showSwiper = false;
            console.log('widthInEms', widthInEms);
            switch (this.slides) {
                case 2:
                    if (this.twoColumnsMaxmimumWidthInEms >= widthInEms) {
                        showSwiper = true;
                        console.log('showSwiper', 2);
                    }
                    break;
                case 3:
                    if (this.threeColumnsMaxmimumWidthInEms >= widthInEms) {
                        showSwiper = true;
                        console.log('showSwiper', 3);
                    }
                    break;
                case 4:
                    if (this.fourColumnsMaxmimumWidthInEms >= widthInEms) {
                        showSwiper = true;
                        console.log('showSwiper', 4);
                    }
                    break;
                case 5:
                    if (this.fourColumnsMaxmimumWidthInEms >= widthInEms) {
                        showSwiper = true;
                        console.log('showSwiper', 5);
                    }
                    break;
                case 6:
                    if (this.fourColumnsMaxmimumWidthInEms >= widthInEms) {
                        showSwiper = true;
                        console.log('showSwiper', 6);
                    }
                    break;
            }
            if (showSwiper) {
                console.log('addSwiper');
                this.addSwiper(overrideSwiper);
            }
            else {
                console.log('destroySwiper');
                this.destroySwiper();
            }
        }, 200);
        onWindowResize();
        window.addEventListener('resize', onWindowResize);
        document.addEventListener('shopify:section:load', (event) => {
            onWindowResize(true);
        });
        if (this.nextElement && this.prevElement) {
            this.nextElement.addEventListener('click', () => {
                if (this.swiper) {
                    this.swiper.slideNext();
                }
            });
            this.prevElement.addEventListener('click', () => {
                if (this.swiper) {
                    this.swiper.slidePrev();
                }
            });
        }
    }
}
export default Tiles;
